import util from '../util';

export const OUTREACH_FORM = 'OUTREACH_FORM';
export const OUTREACH_FORM_REQUEST = util.requestType(OUTREACH_FORM);
export const OUTREACH_FORM_SUCCESS = util.successType(OUTREACH_FORM);
export const OUTREACH_FORM_FAILURE = util.failureType(OUTREACH_FORM);

export const UPDATE_OUTREACH_FORM = 'UPDATE_OUTREACH_FORM';
export const UPDATE_OUTREACH_FORM_REQUEST =
  util.requestType(UPDATE_OUTREACH_FORM);
export const UPDATE_OUTREACH_FORM_SUCCESS =
  util.successType(UPDATE_OUTREACH_FORM);
export const UPDATE_OUTREACH_FORM_FAILURE =
  util.failureType(UPDATE_OUTREACH_FORM);

export const OUTREACH_FORMS_STATUS = 'OUTREACH_FORMS_STATUS';
export const OUTREACH_FORMS_STATUS_REQUEST = util.requestType(
  OUTREACH_FORMS_STATUS,
);
export const OUTREACH_FORMS_STATUS_SUCCESS = util.successType(
  OUTREACH_FORMS_STATUS,
);
export const OUTREACH_FORMS_STATUS_FAILURE = util.failureType(
  OUTREACH_FORMS_STATUS,
);
